import { Contactpersoon } from "@/entities/contactpersoon/domain.ts";
import { BerichtDto, GeneriekBerichtDto, SmsBerichtDto } from "@/shared/types";
import { compareDesc } from "date-fns";
import { onderwerpen } from "./constants";

export type Bericht = GeneriekBericht | SmsBericht;

type BerichtTypeMap = {
    Generiek: GeneriekBericht;
    Sms: SmsBericht;
};

export const Bericht = {
    fromDto(dto: BerichtDto): Bericht {
        switch (dto.type) {
            case "Generiek":
                return GeneriekBericht.fromDto(dto);
            case "Sms":
                return SmsBericht.fromDto(dto);
        }
    },
    isType<T extends keyof BerichtTypeMap>(selectedType: T) {
        return (bericht: Bericht): bericht is BerichtTypeMap[T] => bericht.soort === selectedType;
    },
    sort: (a: Bericht, b: Bericht) => compareDesc(a.verstuurdOp, b.verstuurdOp),
};

interface BaseBericht {
    id: number;
    soort: "Generiek" | "Sms";
    bericht: string;
    verstuurdOp: Date;
}

export type GeneriekBerichtOnderwerp = (typeof onderwerpen)[number];

export interface GeneriekBericht extends BaseBericht {
    soort: "Generiek";
    onderwerp: GeneriekBerichtOnderwerp;
}

export const GeneriekBericht = {
    fromDto(dto: GeneriekBerichtDto): GeneriekBericht {
        return {
            id: dto.id,
            soort: "Generiek",
            bericht: dto.bericht,
            onderwerp: dto.onderwerp,
            verstuurdOp: new Date(dto.verstuurdOpDatumTijd),
        };
    },
};

export interface SmsBericht extends BaseBericht {
    soort: "Sms";
    robId: number;
    ontvangers: Contactpersoon[];
}
export const SmsBericht = {
    fromDto(dto: SmsBerichtDto): SmsBericht {
        return {
            id: dto.id,
            robId: dto.robId,
            soort: "Sms",
            bericht: dto.bericht,
            ontvangers: dto.ontvangers.map((dto) => Contactpersoon.fromDto(dto)),
            verstuurdOp: new Date(dto.verstuurdOpDatumTijd),
        };
    },
};
